import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessagesSquare, User, ChevronRight } from "lucide-react";
import { apiFetch } from "@/lib/api";
import { Eyebrow, PageTitle, PageSubtitle, Loader, EmptyState, Card, BackHeader } from "@/components/common";

export default function ChatsPage() {
  const [chats, setChats] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    apiFetch("/chats").then(setChats).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-3">
      <BackHeader />
      <Eyebrow>COMUNICAZIONE</Eyebrow>
      <PageTitle>Chat</PageTitle>
      <PageSubtitle>Coordina ogni trasporto direttamente.</PageSubtitle>
      {loading ? (
        <Loader />
      ) : chats.length === 0 ? (
        <EmptyState icon={MessagesSquare} title="Nessuna conversazione" text="Quando contatterai un'azienda o un vettore, le tue chat appariranno qui." />
      ) : (
        chats.map((chat) => (
          <Link key={chat.id} to={`/chat/${chat.id}`} state={{ title: chat.title }} data-testid={`chat-item-${chat.id}`}>
            <Card className="flex items-center gap-3 hover:shadow-md">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-secondary">
                <User className="h-5 w-5 text-primary" />
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate font-extrabold text-foreground">{chat.title}</p>
                <p className="truncate text-[13px] text-muted-foreground">{chat.last_message || "Inizia la conversazione"}</p>
              </div>
              {chat.unread_count ? (
                <span className="flex h-6 min-w-6 items-center justify-center rounded-full bg-primary px-2 text-xs font-extrabold text-primary-foreground">
                  {chat.unread_count}
                </span>
              ) : null}
              <ChevronRight className="h-5 w-5 text-muted-foreground" />
            </Card>
          </Link>
        ))
      )}
    </div>
  );
}
